module.exports = __webpack_public_path__ + "media/images/games/rocket-league/logo-610d1489fceffcb469a98670568fca0d.png";